module.exports = __webpack_public_path__ + "img/emily-blackwell.1cf62c38.png";